/**
 * @description  intersection of one array in another array
 * @param arr
 * @param args
 * @returns unknown[] eg: [1, 2, 3] or ['a', 'b', 'c']
 */
export const arrayIntersection = (
  array1: unknown[],
  ...array2: any[]
): unknown[] =>
  array1.filter((item) =>
    array2.every((array2Item) => array2Item.includes(item)),
  );

/**
 * @description simple intersection of item(s) in array
 * @param arr
 * @param args
 * @returns
 */
export const intersection = (arr: any[], ...args: any[]): unknown[] =>
  arr.filter((item) => args.every((arr) => arr.includes(item)));
